// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1KhPw","inputWrap":"styles_inputWrap__2w3lx","input":"styles_input__XzRWx"};